import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Layout() {
  return (
    <div
      className="flex flex-col min-h-screen min-w-full"
      style={{ backgroundColor: "var(--background)" }}
    >
      <div>
        <Header />
      </div>
      <div className="w-full flex-1 mt-4">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
